const ROUTES = {
  SIGNIN: "/",
  LOGOUT: "/logout",
  NOT_FOUND: "*",
  HOME: "/home",
  DASHBOARD: "/dashboard",
  USERS: "/users",
  SALES_PERSON: "/sales-person",
  PENDING_NATIONAL_ID: "/pending-national-id",
  FACTORIES: "/factories",
  SUPPLIERS: "/suppliers-requests",
  Orders: "/orders",
  SOLD_ORDERS: "/sold-orders",
  CATEGORIES: "/categories",
  PENDINGORDERS: "/pending-orders",
  REJECTED_ORDERS: "/rejected-orders",
  REJECTED_BUY_AND_SUPPLY_ORDERS: "/rejected-buy-and-supply-orders",
  PENDINGOFFERS: "/pending-offers",
  EXTEND_TO_BUY_AND_SUPPLY_WALLET: "/extend-to-buy-and-supply-wallet",
  ITEMS: "/items",
  ADMINS: "/admins",
  ADDEDITADMIN: "/add-edit-admin",
  USERSINFORMATION: "/user-information",
  // PURCHASEREQUESTS:"/purchase-requests",
  OFFERS: "/offers",
  /** FACTORY_ADMIN */
  FACTORY_ADMIN_REQUESTS: "factory-admin-requests",
  SUPPLIER_ADMIN_REQUESTS: "supplier-admin-requests",
  NOT_HAVE_ACCESS: "not-have-access",
  LUCKY_HOURS: "lucky-hours",
  EXTENDED_ITEMS: "extended-items",
  SALES_REQUESTS: "sales-requests",
  AUCTIONS: "/auctions",
  PUBLIC_AUCTIONS: "/GM-auctions",
  AUCTION_OFFERS: "/GM-auctions-offers",
  PUBLIC_MAZAD: "/GM-Mazad",
  MAZAD_OFFERS: "/GM-Mazad-offers",
  STORES: "/stores",
  SETTINGS: "/settings",
  STORE_ITEMS: "/store-items",
  STORE_ORDERS: "/store-orders",
  STORE_CATEGORIES: "/store-categories",
  STORE_SUBCATEGORIES: "/store-subcategories",
  AUCTION_REPORT: "/auction-report",
  // BUY: "/buy-items",
  BUY_AND_SUPPLY: "/buy-and-supply",
  BUYPENDINGORDERS: "/buy-pending-orders",
  // SUPPLY: "/supply-types",
  // SUPPLYPENDINGORDERS: "/supply-pending-orders",
  ACCEPTED_BUY_AND_SUPPLY_REPORT: "/accepted-buy-and-supply-report",
  SALES_PERSON_REPORT: "/sales-person-report",
  MERCHANT_STORE: "/merchant-store",
  RECEIVED_CONFIRMATION: "/received-confirmations",
  WITHDRAWLS: "/Withdrawls",
  PENDING_CACH_REQUEST: "/pending-cash-request",
};

export default ROUTES;
